<template>
    <div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Products</h1>
      <div class="title-right float-right">
      </div>
   </div>-->
      <div class="new-rfq">
      <fieldset class="customer-search customer-search-new mb-3">
               <div class="row">
                    <div class="col-sm-9 col-md-9">
                        <form class="form-inline" action="">
                            <div class="form-group">
                                <select class="form-control"  v-model="filterForm.status_filter">
                                    <option value="">All</option>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                            </div>
                            <div class="input-group quick-search">
                                <div class="listsearch-box">
                                    
                                    <v-select label="company_name" placeholder="Select Customer" v-model="filterForm.customer_id" :filterable="false" :options="options" :reduce="(option) => option.id" @search="onSearch">
                                        <template slot="no-options">
                                        Search Customer
                                        </template>
                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.company_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.company_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                    <!-- <div class="custom-slect-drop">
                                        <div
                                            class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select">
                                            <select class="form-control select2 mdl-textfield__input" id="customer_id"
                                                    name="customer_id">
                                                <option value="">- Search Customer For Quote -</option>
                                            </select>
                                            <label for="customer_id" class="mdl-textfield__label">Customer</label>
                                        </div>
                                    </div> -->

    <!--                                <select class="form-control mdl-textfield__input" id="customer_id"-->
    <!--                                        name="customer_id">-->
    <!--                                    <option value="">- Search Customer -</option>-->
    <!--                                </select>-->
    <!--                                <input  v-model="filterForm.search_filter" type="text" class="form-control quick-search" placeholder="Quick Search">-->
                                </div>
                            </div>
                            <div class="input-group quick-search2">
                                <div class="form-group2">
                                    
                                    <input class="form-control" placeholder="Product No" v-model="filterForm.product_number" type="text" name="product_name" />
                                    
                                </div>
                            </div>

                            <div class="input-group quick-search2">
                                <div class="form-group2">
                                    
                                    <input class="form-control" placeholder="Product Name	" v-model="filterForm.product_name" type="text" name="product_name" />
                                    
                                </div>
                            </div>

                            <div class="input-group quick-search2">
                                <div class="form-group2">
                                    
                                    <input class="form-control" placeholder="Product Description" v-model="filterForm.product_description" type="text" name="product_name" />
                                    
                                </div>
                            </div>

                            <div class="input-group quick-search2">
                                <div class="form-group2">
                                    
                                    <input class="form-control" placeholder="Customer SKU" v-model="filterForm.customer_sku" type="text" name="product_name" />
                                    
                                </div>
                            </div>
                            
                            <div class="search-btn-sec">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" @click.prevent="filterSearch" type="button"><i class="ri-search-line search-icon"></i></button>
                                </div>
                            </div>
                            

                        </form>
                    </div>
                    <div class="col-sm-3 col-md-3">
                        <div class="btnrow float-right">
<!--                        <button type="button" class="btn importModal" data-toggle="modal" data-target="#importModal">-->
<!--                            <i class="fas fa-file-import"></i>-->
<!--                        </button>-->
                        <button type="button" class="btn create-btn" data-toggle="modal" data-target="#productAddModal">
                            Create Product
                        </button>
                        <!-- <router-link :to="{ name: 'addProducts'}" class="btn create-btn">
                            <i class="fa fa-plus" aria-hidden="true"></i> Create Product
                            </router-link> -->
                        </div>
                    </div>
               </div>
            </fieldset>
            <!-- The Modal -->
      </div>
        <ProductList  ref="ProductList" :bus="bus" :status_filter="filterForm.status_filter" :customer_filter="filterForm.customer_id" :product_number="filterForm.product_number" :product_name="filterForm.product_name" :product_description="filterForm.product_description" :customer_sku="filterForm.customer_sku" ></ProductList>
      <!-- Delete Modal HTML -->
        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
   <ProductAddModal @productDataSaved="customerDataSaved($event)"></ProductAddModal>
   
</div>
</template>
<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vue from "vue";
import ProductList from "../../components/ProductList";
import ProductAddModal from "../../components/ProductAddModal";
export default {
    name: "CustomerList",
    components: {
        ProductList,ProductAddModal
    },
    created() {
         if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.setSuccessMessage(null);
        //this.getCustomers();
    },
    data(){
        return {
            selected: '2',
            selectedAjax: '-1',
            options: [{ id: 1, text: 'Hello' }, { id: 2, text: 'World' }],
            optionsAjax: [{ id: -1, text: '' }],
            bus: new Vue(),
            selected:[],
            options:[
                        // { label: 'Select More Column', id: 0 },
                        // { label: 'General phone number', id: 1 },
                        // { label: 'Billing email', id: 2 },
                        // { label: 'Total number of quotes', id: 3 },
                        // { label: 'Total number of orders', id: 4 },
                    ],
            customerData: {
                customers: {
                    data:[]
                },
                config: null,
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null,

            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: '',
                customer_id:null,
                product_number:null,
                product_name:null,
                product_description:null,
                customer_sku:null,
            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        customerDataSaved(){
            this.bus.$emit('getCustomers');
        },
        filterSearch() {
            this.bus.$emit('getCustomers')
        },
        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            // fetch(
            //     `https://api.github.com/search/repositories?q=${escape(search)}`
            // ).then(res => {
            //     res.json().then(json => (vm.options = json.items));
            //     loading(false);
            // });

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('customers.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                //   allData.forEach((value, index) => {
                //        console.log(value.id);
                //         // createSeriesData[index] = {
                //         //     data: data.usersQuotechart[userIndex+1][index+1],
                //         //     name: "Total Quotes"
                //         // };


                //     });
                    vm.options = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        // onSearch(search, loading) {
        //     if(search.length) {
        //         loading(true);
        //         //customers.search
        //         console.log("search",search);
        //         this.search(loading, search, this);

        //     }
        // },
        // search:_.debounce((loading, search, vm) => {
        //    let self = this;
        //         this.setCustomerLoading(true);
        //         this.setCommonErrors([]);
        //         this.setErrorMessage(null);
        //         return axios.get(window.route('customers.search',{search: search} ), {

        //             validateStatus: function (status) {
        //                 return status < 500; // Resolve only if the status code is less than 500
        //             }
        //         })
        //         .then(({ data }) => {

        //             if(data.errors){
        //                 self.setCommonErrors(data.errors);
        //             } else if(data.errorMessage != null){
        //                 self.setErrorMessage(data.errorMessage);
        //             } else {
        //                 loading(false);
        //                 console.log(data);
        //                 // this.customerData = data.data;
        //                 // this.current_page = data.data.current_page;
        //                 // this.per_page = data.data.per_page;
        //                 // this.total = data.data.total;
        //                 //this.setCustomers(data.data);
        //             }
        //         })
        //         .catch((error) => {
        //             self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

        //         })
        //         .finally(() => {
        //             self.setCustomerLoading(false);

        //         });
        // }, 350),


    },




     mounted: function() {
        //   var vm = this;
        //   $('#customer_id')
        //     // init select2
        //     .select2();
        },
    // mounted() {
    //     setTimeOut(() => {
    //         let unit = $('#customer_id'); // or document.querySelector('#unit');
    //         unit.select2();
    //     }, 100);
    // },
    watch: {
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>
#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}
	.select2-selection {
		border-radius: 0px !important;
		text-align: left !important;
	}
	.select2-dropdown {
		border-radius: 0px !important;
	}
</style>

